// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__st7Zp","socialIcons":"Footer_socialIcons__3OPAC","socialIcon":"Footer_socialIcon__1Cc0G"};